import "./src/styles/index.scss";
import { isIosStockSafari } from "./src/utils/iosStockSafari";
import { wrapPageElement } from "./src/components/WrapPageElement";

export { wrapPageElement };

export const onClientEntry = () => {
  if (typeof document === "undefined") {
    return;
  }
  if (isIosStockSafari()) {
    document.documentElement.classList.add("ios-stock-safari");
  }
};

/** Scroll to top when navigating to another page (e.g. mobile menu → subpage). */
function scrollWindowToTop() {
  window.scrollTo(0, 0);
  if (typeof document !== "undefined") {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }
}

/**
 * Tell Gatsby’s scroll handler to jump to the top on route changes (not same-path hash-only).
 */
export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  const nextPath = routerProps?.location?.pathname;
  const prevPath = prevRouterProps?.location?.pathname;
  if (prevPath != null && nextPath != null && nextPath !== prevPath) {
    return [0, 0];
  }
  return true;
};

/**
 * Extra pass after paint — avoids occasional stale scroll when leaving the overlay / iOS WebKit.
 */
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window === "undefined") {
    return;
  }
  if (
    !prevLocation ||
    !location ||
    location.pathname === prevLocation.pathname
  ) {
    return;
  }
  requestAnimationFrame(() => {
    scrollWindowToTop();
  });
};
